import { nodeRedApi } from '../../../services/axios';

export async function Agendamento(grupo, inicio, fim, on, off, tipo) {
  console.log(`grupo: ${grupo} inicio: ${inicio} fim: ${fim} on: ${on} off: ${off} tipo: ${tipo}`);

  try {
    const { data } = await nodeRedApi.post('/agendar', {
      grupo,
      inicio,
      fim,
      on,
      off,
      tipo,
    });

    console.log("Agendamento realizado:", data);
    return data;
  } catch (error) {
    console.error("Erro na requisição HTTP POST:", error);
    return null;
  }
}